module.exports = __webpack_public_path__ + "img/accounting-yearly-management.d53d2b41.svg";